import { SxProps } from '@mui/material';
import styled from 'styled-components';

export const Input = styled.input`
    display: none;
`;

export const ButtonContent = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const FileContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 16px;
`;

export const DialogActionsStyles: SxProps = {
    display: 'flex',
    padding: '8px 0 16px 0',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
};
